import { schema } from "normalizr";
import { Brand } from "./brand";

export const Brands = new schema.Array(Brand);
